var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirefoxIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6367 8.13816C22.1257 6.90906 21.0908 5.58211 20.2781 5.16271C20.9395 6.45937 21.3223 7.76009 21.4686 8.73084C21.4686 8.73275 21.4693 8.7375 21.4709 8.75041C20.1415 5.43681 17.8872 4.10067 16.0464 1.19141C15.9535 1.0443 15.8603 0.896804 15.7695 0.741331C15.7233 0.661932 15.6801 0.580771 15.64 0.498094C15.5636 0.350449 15.5046 0.194389 15.4643 0.0330465C15.4649 0.0172937 15.4532 0.00354681 15.4376 0.00154103C15.4304 -0.000513675 15.4227 -0.000513675 15.4155 0.00154103C15.4138 0.00212808 15.4114 0.00403602 15.4096 0.00472092C15.407 0.00574827 15.4038 0.0080965 15.401 0.00961307C15.4023 0.0078519 15.4051 0.00388926 15.4059 0.00295975C12.4525 1.73263 11.4506 4.93234 11.3585 6.53319C10.1793 6.61426 9.05145 7.04887 8.12277 7.7801C8.02552 7.69796 7.92386 7.62121 7.81824 7.55017C7.55029 6.61269 7.5389 5.62027 7.78526 4.67692C6.57749 5.22684 5.6381 6.09613 4.95516 6.86371H4.94973C4.48365 6.27337 4.51653 4.326 4.54309 3.91942C4.53752 3.89422 4.19541 4.097 4.1506 4.12758C3.73931 4.42115 3.35484 4.75054 3.00163 5.11188C2.59969 5.51949 2.23248 5.95988 1.90373 6.4285C1.90373 6.42909 1.90339 6.42977 1.90319 6.43036C1.90319 6.42972 1.90353 6.42909 1.90373 6.4285C1.14775 7.49983 0.611518 8.71044 0.326159 9.99023C0.320533 10.0157 0.315788 10.0421 0.310309 10.0678C0.288196 10.1713 0.208552 10.6891 0.19461 10.8016C0.193533 10.8103 0.193044 10.8186 0.192017 10.8273C0.089037 11.3626 0.0252924 11.9048 0.00122302 12.4494C0.00122302 12.4694 0 12.4893 0 12.5094C0.000195686 19.0019 5.26415 24.265 11.7572 24.265C17.5723 24.265 22.4006 20.0436 23.3458 14.4988C23.3657 14.3483 23.3817 14.197 23.3992 14.0452C23.6329 12.0292 23.3733 9.91014 22.6367 8.13816ZM9.0857 17.34C9.14068 17.3663 9.19234 17.395 9.2488 17.4202C9.25115 17.4218 9.25438 17.4236 9.25677 17.4251C9.19929 17.3976 9.1423 17.3692 9.0857 17.34ZM21.4718 8.7533L21.4703 8.7419C21.4708 8.74606 21.4716 8.75041 21.4722 8.75457L21.4718 8.7533Z",
    fill: "url(#paint0_linear_7256_89040)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6366 8.13805C22.1256 6.90895 21.0907 5.582 20.278 5.1626C20.9394 6.45926 21.3222 7.75999 21.4685 8.73073C21.4685 8.7279 21.469 8.73308 21.4703 8.74179C21.4709 8.74595 21.4716 8.7503 21.4722 8.75446C22.5815 11.7617 21.9772 14.8196 21.1063 16.6883C19.7591 19.5796 16.4972 22.5427 11.3917 22.3982C5.87557 22.242 1.016 18.1491 0.10885 12.7884C-0.0564554 11.943 0.10885 11.5138 0.192017 10.8274C0.0907004 11.3565 0.0521014 11.5094 0.00122306 12.4495C0.00122306 12.4696 0 12.4894 0 12.5095C9.7843e-05 19.0018 5.26405 24.2649 11.7571 24.2649C17.5722 24.2649 22.4005 20.0435 23.3457 14.4987C23.3656 14.3482 23.3816 14.1969 23.3991 14.0451C23.6328 12.0291 23.3732 9.91003 22.6366 8.13805Z",
    fill: "url(#paint1_radial_7256_89040)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6366 8.13805C22.1256 6.90895 21.0907 5.582 20.278 5.1626C20.9394 6.45926 21.3222 7.75999 21.4685 8.73073C21.4685 8.7279 21.469 8.73308 21.4703 8.74179C21.4709 8.74595 21.4716 8.7503 21.4722 8.75446C22.5815 11.7617 21.9772 14.8196 21.1063 16.6883C19.7591 19.5796 16.4972 22.5427 11.3917 22.3982C5.87557 22.242 1.016 18.1491 0.10885 12.7884C-0.0564554 11.943 0.10885 11.5138 0.192017 10.8274C0.0907004 11.3565 0.0521014 11.5094 0.00122306 12.4495C0.00122306 12.4696 0 12.4894 0 12.5095C9.7843e-05 19.0018 5.26405 24.2649 11.7571 24.2649C17.5722 24.2649 22.4005 20.0435 23.3457 14.4987C23.3656 14.3482 23.3816 14.1969 23.3991 14.0451C23.6328 12.0291 23.3732 9.91003 22.6366 8.13805Z",
    fill: "url(#paint2_radial_7256_89040)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9249 9.52C16.9505 9.538 16.9738 9.55591 16.9979 9.57381C16.7029 9.05016 16.3354 8.57068 15.9065 8.14961C12.2518 4.49537 14.9482 0.226189 15.4029 0.00936939C15.4042 0.00760821 15.4069 0.00364557 15.4078 0.00271606C12.4544 1.73238 11.4525 4.93209 11.3604 6.53295C11.4974 6.52346 11.634 6.51197 11.7734 6.51197C13.9774 6.51197 15.8969 7.72375 16.9249 9.52Z",
    fill: "url(#paint3_radial_7256_89040)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7767 10.2499C11.7575 10.5423 10.7242 11.5508 10.3629 11.5508C7.01966 11.5508 6.47697 13.573 6.47697 13.573C6.62506 15.276 7.81062 16.6783 9.24647 17.4203C9.31197 17.4542 9.37826 17.4848 9.4446 17.515C9.55834 17.5653 9.6735 17.6125 9.78994 17.6562C10.2822 17.8305 10.7979 17.93 11.3198 17.9512C17.1796 18.2261 18.3148 10.946 14.086 8.83189C15.169 8.64354 16.2931 9.07909 16.9209 9.52006C15.8929 7.72396 13.9734 6.51218 11.7694 6.51218C11.63 6.51218 11.4935 6.52367 11.3565 6.53316C10.1772 6.61423 9.04936 7.04885 8.12069 7.78007C8.29994 7.93173 8.50227 8.13446 8.92858 8.5544C9.72609 9.34042 11.7724 10.1544 11.7767 10.2499Z",
    fill: "url(#paint4_radial_7256_89040)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7767 10.2499C11.7575 10.5423 10.7242 11.5508 10.3629 11.5508C7.01966 11.5508 6.47697 13.573 6.47697 13.573C6.62506 15.276 7.81062 16.6783 9.24647 17.4203C9.31197 17.4542 9.37826 17.4848 9.4446 17.515C9.55834 17.5653 9.6735 17.6125 9.78994 17.6562C10.2822 17.8305 10.7979 17.93 11.3198 17.9512C17.1796 18.2261 18.3148 10.946 14.086 8.83189C15.169 8.64354 16.2931 9.07909 16.9209 9.52006C15.8929 7.72396 13.9734 6.51218 11.7694 6.51218C11.63 6.51218 11.4935 6.52367 11.3565 6.53316C10.1772 6.61423 9.04936 7.04885 8.12069 7.78007C8.29994 7.93173 8.50227 8.13446 8.92858 8.5544C9.72609 9.34042 11.7724 10.1544 11.7767 10.2499Z",
    fill: "url(#paint5_radial_7256_89040)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57333 7.38931C7.65522 7.44214 7.73643 7.49595 7.81701 7.55075C7.54906 6.61326 7.53767 5.62084 7.78403 4.67749C6.57626 5.22742 5.63687 6.0967 4.95393 6.86428C5.01043 6.86267 6.71578 6.83199 7.57333 7.38931Z",
    fill: "url(#paint6_radial_7256_89040)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.111234 12.7889C1.01838 18.1496 5.87795 22.2425 11.3941 22.3987C16.4996 22.5432 19.7615 19.5798 21.1087 16.6888C21.9795 14.82 22.5839 11.7624 21.4746 8.75494L21.4742 8.75366L21.4726 8.74227C21.4714 8.73356 21.4707 8.72837 21.4709 8.73121C21.4709 8.73312 21.4716 8.73786 21.4732 8.75078C21.8902 11.4738 20.505 14.1118 18.3397 15.8955L18.3332 15.9108C14.114 19.3462 10.0765 17.9835 9.25906 17.4257C9.20163 17.398 9.14454 17.3696 9.08783 17.3404C6.62796 16.1649 5.61177 13.9238 5.82967 12.0019C3.75261 12.0019 3.04437 10.2501 3.04437 10.2501C3.04437 10.2501 4.90921 8.92044 7.36697 10.0768C9.64329 11.1479 11.7811 10.2502 11.7813 10.2501C11.7769 10.1546 9.73066 9.34062 8.93295 8.55465C8.5067 8.13471 8.30431 7.93222 8.12506 7.78032C8.0278 7.69818 7.92615 7.62143 7.82052 7.55039C7.73985 7.4957 7.65864 7.44188 7.57685 7.38895C6.71935 6.83164 5.01395 6.86231 4.95744 6.86378H4.95201C4.48594 6.27344 4.51881 4.32608 4.54538 3.91949C4.5398 3.89429 4.19769 4.09707 4.15288 4.12765C3.7416 4.42123 3.35712 4.75062 3.00391 5.11195C2.60197 5.51966 2.23472 5.96015 1.90602 6.42887C1.90602 6.42945 1.90567 6.43014 1.90548 6.43073C1.90548 6.43009 1.90582 6.42945 1.90602 6.42887C1.15003 7.5002 0.613804 8.71081 0.328445 9.99059C0.322819 10.0161 -0.0947257 11.8419 0.111234 12.7889Z",
    fill: "url(#paint7_radial_7256_89040)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.904 8.14961C16.3329 8.57067 16.7004 9.05015 16.9954 9.57381C17.0601 9.62244 17.1206 9.67092 17.1719 9.71822C19.8373 12.1741 18.4407 15.6475 18.3366 15.895C20.5019 14.1114 21.8871 11.4734 21.4701 8.75036C20.1406 5.43681 17.8864 4.10067 16.0456 1.19141C15.9527 1.0443 15.8595 0.896804 15.7687 0.741331C15.7224 0.661932 15.6792 0.580771 15.6392 0.498094C15.5627 0.350449 15.5037 0.194389 15.4634 0.0330464C15.464 0.0172937 15.4523 0.00354681 15.4367 0.00154103C15.4295 -0.000513675 15.4219 -0.000513675 15.4147 0.00154103C15.413 0.00212808 15.4106 0.00403602 15.4088 0.00472092C15.4062 0.00574827 15.4029 0.0080965 15.4002 0.00961307C14.9457 0.226237 12.2493 4.49542 15.904 8.14961Z",
    fill: "url(#paint8_radial_7256_89040)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1706 9.71869C17.1192 9.67139 17.0588 9.62291 16.9941 9.57428C16.9701 9.55627 16.9467 9.53837 16.921 9.52046C16.2933 9.07949 15.1691 8.64394 14.0862 8.83229C18.315 10.9464 17.1797 18.2265 11.3199 17.9516C10.7981 17.9304 10.2824 17.8309 9.79007 17.6566C9.67364 17.6128 9.55848 17.5657 9.44474 17.5154C9.3784 17.4852 9.31211 17.4546 9.2466 17.4207C9.24895 17.4224 9.25218 17.4242 9.25458 17.4256C10.0721 17.9833 14.1095 19.3461 18.3287 15.9107L18.3352 15.8954C18.4394 15.6482 19.8359 12.1746 17.1706 9.71869Z",
    fill: "url(#paint9_radial_7256_89040)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47783 13.5733C6.47783 13.5733 7.02052 11.5511 10.3638 11.5511C10.7252 11.5511 11.7585 10.5426 11.7776 10.2501C11.7967 9.95768 9.63972 11.1479 7.36326 10.0769C4.9055 8.9205 3.04066 10.2501 3.04066 10.2501C3.04066 10.2501 3.7489 12.002 5.82595 12.002C5.60811 13.9239 6.6243 16.1652 9.08412 17.3405C9.13911 17.3667 9.19077 17.3955 9.24723 17.4207C7.81148 16.6786 6.62592 15.2762 6.47783 13.5733Z",
    fill: "url(#paint10_radial_7256_89040)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6365 8.13816C22.1255 6.90906 21.0906 5.58211 20.2779 5.16271C20.9393 6.45937 21.3221 7.76009 21.4684 8.73084C21.4684 8.73275 21.4691 8.7375 21.4707 8.75041C20.1413 5.43681 17.887 4.10067 16.0462 1.19141C15.9533 1.0443 15.8601 0.896804 15.7693 0.741331C15.7231 0.661932 15.6799 0.580771 15.6399 0.498094C15.5634 0.350449 15.5044 0.194389 15.4641 0.0330465C15.4647 0.0172937 15.453 0.00354681 15.4374 0.00154103C15.4302 -0.000513675 15.4225 -0.000513675 15.4153 0.00154103C15.4136 0.00212808 15.4112 0.00403602 15.4094 0.00472092C15.4068 0.00574827 15.4036 0.0080965 15.4008 0.00961307C15.4021 0.0078519 15.4049 0.00388926 15.4057 0.00295975C12.4523 1.73263 11.4504 4.93234 11.3583 6.53319C11.4953 6.5237 11.6319 6.51221 11.7713 6.51221C13.9754 6.51221 15.895 7.72399 16.9228 9.52009C16.295 9.07911 15.1709 8.64357 14.0879 8.83191C18.3167 10.946 17.1815 18.2261 11.3217 17.9513C10.7998 17.93 10.2841 17.8305 9.79183 17.6562C9.6754 17.6124 9.56023 17.5654 9.44649 17.515C9.38015 17.4848 9.31387 17.4542 9.24836 17.4204C9.25071 17.422 9.25394 17.4238 9.25633 17.4253C9.1989 17.3976 9.14181 17.3692 9.08511 17.34C9.1401 17.3663 9.19176 17.395 9.24821 17.4202C7.81237 16.6781 6.6268 15.2758 6.47872 13.5728C6.47872 13.5728 7.02141 11.5507 10.3647 11.5507C10.7261 11.5507 11.7594 10.5422 11.7785 10.2497C11.7741 10.1542 9.72784 9.34026 8.93013 8.55429C8.50387 8.13434 8.30149 7.93186 8.12224 7.77996C8.02498 7.69782 7.92332 7.62106 7.8177 7.55003C7.54976 6.61254 7.53836 5.62012 7.78473 4.67677C6.57695 5.2267 5.63756 6.09598 4.95462 6.86356H4.94919C4.48311 6.27322 4.51599 4.32586 4.54255 3.91927C4.53698 3.89408 4.19487 4.09685 4.15006 4.12743C3.73877 4.42101 3.3543 4.7504 3.00109 5.11173C2.5993 5.51939 2.23214 5.95983 1.90353 6.4285C1.90353 6.42909 1.90319 6.42977 1.903 6.43036C1.903 6.42972 1.90334 6.42909 1.90353 6.4285C1.14755 7.49983 0.611323 8.71044 0.325964 9.99023C0.320338 10.0157 0.315592 10.0421 0.310113 10.0678C0.288001 10.1713 0.188494 10.6966 0.174601 10.8093C0.173524 10.8179 0.175628 10.8007 0.174601 10.8093C0.0838514 11.3521 0.0259773 11.8998 0.00122302 12.4496C0.00122302 12.4697 0 12.4895 0 12.5096C0 19.0019 5.26395 24.265 11.757 24.265C17.5721 24.265 22.4004 20.0436 23.3456 14.4988C23.3655 14.3483 23.3815 14.197 23.399 14.0452C23.6327 12.0292 23.3731 9.91014 22.6365 8.13816ZM21.4702 8.7419C21.4708 8.74606 21.4715 8.75041 21.4721 8.75457L21.4717 8.7533L21.4702 8.7419Z",
    fill: "url(#paint11_linear_7256_89040)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7256_89040",
    x1: 20.4885,
    y1: 3.76106,
    x2: 2.20734,
    y2: 22.5907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E31587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_7256_89040",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.5663 2.6984) scale(30.0575 30.0574)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FF3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EB0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E50080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E50080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_7256_89040",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.5304 12.8231) scale(30.0575 30.0574)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#960E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#B11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DB293D",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F5334B",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3750",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_7256_89040",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0664 -1.14581) scale(13.3995 13.3995)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_7256_89040",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.85402 19.1161) scale(11.4466 11.4466)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A8EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3A8EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#9059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C139E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_7256_89040",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.6385 10.2896) scale(6.07815 6.75351)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9059FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#9059FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6E008B",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E008B",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_7256_89040",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.9664 1.80423) scale(8.33245)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FF7139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_7256_89040",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.5529 -3.66212) scale(39.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E31587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_7256_89040",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.2361 -2.96578) scale(55.4422 55.4422)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E31587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_7256_89040",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.0509 4.80119) scale(22.7592 22.7591)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E31587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_7256_89040",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.9588 6.10883) scale(27.3558 27.3558)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7256_89040",
    x1: 18.7858,
    y1: 3.39709,
    x2: 4.22682,
    y2: 20.3826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFF44F",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFF44F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF44F",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefoxIcon);
export default __webpack_public_path__ + "static/media/firefox-icon.152722e254ceb96dd425f22d5c1770e1.svg";
export { ForwardRef as ReactComponent };